<div class="page-layout-small padding-large m-margin-none m-padding m-padding-top-largest">
	<div class="flex margin-bottom">
		<div class="flex-1 flex center">
			<h4>Search Templates</h4>
		</div>
	</div>

	<div class="flex wrap gap">
		<div class="filter-chip" [ngClass]="!templateFilters.brands || !templateFilters.brands.length ? '' : 'selected'">
			@if (templateFilters.brands && templateFilters.brands.length) {
				<div class="flex center hover" (click)="openBrandFilterModal()">
					<b class="margin-right-smallest">Brand:</b>

					@for (brand of templateFilters.brands; track brand; let last = $last) {
						{{ brand.name }}
						@if (!last) {
							,
						}
					}
				</div>
				<mat-icon class="hover" (click)="cleanFilter('brands')">close</mat-icon>
			} @else {
				<div class="flex center hover" (click)="openBrandFilterModal()">
					Brand
					<mat-icon class="hover">edit</mat-icon>
				</div>
			}
		</div>

		<div class="filter-chip" [ngClass]="!templateFilters.categories || !templateFilters.categories.length ? '' : 'selected'">
			@if (templateFilters.categories && templateFilters.categories.length) {
				<div class="flex center hover" (click)="openCategoryFilterModal()">
					<b class="margin-right-smallest">Category:</b>
					@for (category of templateFilters.categories; track category; let last = $last) {
						{{ category.name }}
						@if (!last) {
							,
						}
					}
				</div>
				<mat-icon class="hover" (click)="cleanFilter('categories')">close</mat-icon>
			} @else {
				<div class="flex center hover" (click)="openCategoryFilterModal()">
					Category
					<mat-icon class="hover">edit</mat-icon>
				</div>
			}
		</div>

		<div class="filter-chip disabled" [ngClass]="!templateFilters.styleGroups || !templateFilters.styleGroups.length ? '' : 'selected'">
			@if (templateFilters.styleGroups && templateFilters.styleGroups.length) {
				<div class="flex center hover" (click)="openStyleGroupFilterModal()">
					<b class="margin-right-smallest">Style Group:</b>
					@for (styleGroup of templateFilters.styleGroups; track styleGroup; let last = $last) {
						{{ styleGroup.name }}
						@if (!last) {
							,
						}
					}
				</div>
				<mat-icon class="hover" (click)="cleanFilter('styleGroups')">close</mat-icon>
			} @else {
				<div class="flex center hover" (click)="openStyleGroupFilterModal()">
					Style Group
					<mat-icon class="hover">edit</mat-icon>
				</div>
			}
		</div>

		<div class="filter-chip disabled" [ngClass]="!templateFilters.teams || !templateFilters.teams.length ? '' : 'selected'">
			@if (templateFilters.teams && templateFilters.teams.length) {
				<div class="flex center hover" (click)="openTeamFilterModal()">
					<b class="margin-right-smallest">Team:</b>
					@for (team of templateFilters.teams; track team; let last = $last) {
						{{ team.name }}
						@if (!last) {
							,
						}
					}
				</div>
				<mat-icon class="hover" (click)="cleanFilter('teams')">close</mat-icon>
			} @else {
				<div class="flex center hover" (click)="openTeamFilterModal()">
					Team
					<mat-icon class="hover">edit</mat-icon>
				</div>
			}
		</div>
	</div>

	@if (templates && templates.items && templates.items.length) {
		<div class="flex column end between margin-bottom margin-top-small">
			<button [routerLink]="['/company/template-detail/new']" class="flex center">
				<i class="fa fa-solid fa-plus margin-right-smallest"></i>
				Create Template
			</button>
		</div>

		<bt-paginator [pageNumber]="templates.currentPage" [pageSize]="templates.size" [totalNumber]="templates.totalCount" (clickPage)="pageEvent($event)"></bt-paginator>

		@for (item of templates.items; track item) {
			<div class="margin-bottom">
				<div class="flex center margin-bottom-smallest between">
					<div class="flex center">
						<!-- @if (!item.isDefault) {
							<i class="primary-dark hover margin-right-small hover fa {{ item.selected ? 'fa-solid fa-check-square' : 'fa-regular fa-square' }}" (click)="selectTemplate(item)"></i>
					}-->
						<div class="flex center">
							<span class="margin-right-smallest primary">Template {{ item.id }}</span>
							@if (item.isDefault) {
								<span class="bg-primary white flex center radius padding-right-smallest padding-left-smallest small">Default Template</span>
							}
						</div>
					</div>

					@if (item.isDefault) {
						<span class="grey flex center small">
							<i class="fa fa-solid fa-lock margin-right-small"></i>
							This template is used as default for styles without a specific template.
						</span>
					}
				</div>

				<div class=" flex padding-small radius  {{ item.isDefault ? 'bg-light-grey' : 'border' }}">
					<div class="flex-1">
						<div class="flex center">
							<span>Brand:</span>
							<b class="margin-left-smallest">{{ item.brand?.name || 'All' }}</b>
						</div>
						<div class="flex">
							<div class="arrow"></div>
							<div class="flex column padding-top-smallest padding-left-smallest">
								<div class="flex center">
									<span>Categories:</span>
									<b class="margin-left-smallest">{{ item.category?.name || 'All' }}</b>
								</div>
								<div class="flex">
									<div class="arrow"></div>
									<div class="flex column padding-top-smallest padding-left-smallest">
										<div class="flex center">
											<span>Styles:</span>

											@for (style of item.styles; track $index; let last = $last) {
												<b class="margin-left-smallest">{{ style.code }}</b>
												@if (!$last) {
													<span>,</span>
												}
											}
											@if (!item.styles || !item.styles.length) {
												<b class="margin-left-smallest">All</b>
											}
										</div>
										<div class="flex">
											<div class="arrow"></div>
											<div class="flex column padding-top-smallest padding-left-smallest">
												<div class="flex center">
													<span>Colors:</span>
													@if (item.styles && item.styles.length == 1) {
														@for (color of item.styles[0].colors; track $index; let last = $last) {
															<b class="margin-left-smallest">{{ color.name }}</b>
															@if (!$last) {
																<span>,</span>
															}
														} @empty {
															<b class="margin-left-smallest">All</b>
														}
													} @else {
														<b class="margin-left-smallest">All</b>
													}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="flex column end between">
						<div class="grey bg-light-grey radius padding-right-smallest padding-left-smallest">{{ item.shots?.length || 0 }} shots</div>
						<div class="flex center">
							@if (!item.isDefault) {
								<span class="flex red center margin-right-small hover" (click)="removeTemplate(item)">
									<i class="fa fa-xmark margin-right-smallest"></i>
									Remove
								</span>
							}

							<a [routerLink]="['/company/template-detail/' + item.id]" class="hover flex center primary">
								<button class="mini">
									<i class="fa fa-solid fa-eye margin-right-smallest"></i>
									View details
								</button>
							</a>
						</div>
					</div>
				</div>
			</div>
		}

		<bt-paginator [pageNumber]="templates.currentPage" [pageSize]="templates.size" [totalNumber]="templates.totalCount" (clickPage)="pageEvent($event)"></bt-paginator>
	}

	@if (templates.items.length == 0 && !loading) {
		<div class="flex center bg-light-grey padding-largest justify-center">
			<div class="flex column center gap">
				<i class="fa fa-search fa-2xl margin-bottom grey"></i>
				<span>No data found</span>
			</div>
		</div>
	}
</div>

@if (loading) {
	<bt-loader></bt-loader>
}
